import React from 'react'
import { array, func, object, bool, number } from 'prop-types'
import { FixedSizeGrid as Grid } from 'react-window'
import { useWindowDimensions } from '../../../providers/WindowDimensionsProvider'
import { EMPTY_ARRAY, EMPTY_OBJECT, RESPONSIVE_BREAKPOINTS } from '../../../utils/constants'
import ListItem from './ListItem'

const createGridConfig = (width, height, desktopColumns) => {
  if (width < RESPONSIVE_BREAKPOINTS.small) {
    return { width: width - 32, height: height - 248, columnCount: 1, columnWidth: width - 40 }
  } else if (width <= RESPONSIVE_BREAKPOINTS.large) {
    return { width: width - 80, height: 338, columnCount: 2, columnWidth: (width - 84) / 2 }
  }
  const columnWidth = 240
  return { width: (desktopColumns * columnWidth) + 30, height: 338, columnCount: desktopColumns, columnWidth }
}

const createGridableItems = (items, columns) => {
  const gridableItems = []
  for (let i = 0; i < items.length; i += columns) {
    const row = items.slice(i, i + columns)
    gridableItems.push(row)
  }
  return gridableItems
}

export const VirtualizedList = ({
  onClick,
  items = EMPTY_ARRAY,
  isInnerHtml = false,
  listItemProps = EMPTY_OBJECT,
  desktopColumns = 4,
  ...rest
}) => {
  const { width = window.innerWidth, height = window.innerHeight } = useWindowDimensions() || {}
  const gridConfig = createGridConfig(width, height, desktopColumns)
  const gridableItems = createGridableItems(items, gridConfig.columnCount)

  return (
    <Grid
      itemData={gridableItems}
      rowCount={gridableItems.length}
      rowHeight={26}
      className={'ad-list'}
      {...gridConfig}
      {...rest}
    >
      {({ data, columnIndex, rowIndex, style }) => {
        const item = data[rowIndex][columnIndex]
        if (!item) return null

        const index = rowIndex * gridConfig.columnCount + columnIndex
        return <ListItem
          item={item}
          index={index}
          onClick={onClick}
          isInnerHtml
          key={item.name + index}
          listItemProps={listItemProps}
          style={style}
        />
      }}
    </Grid>
  )
}

VirtualizedList.propTypes = {
  items: array,
  listItemProps: object,
  isInnerHtml: bool,
  onClick: func,
  desktopColumns: number
}

export default React.memo(VirtualizedList)
